import type { BigNumberish } from '@ethersproject/bignumber';
import { formatUnits } from '@ethersproject/units';

const bigNumberToNumber = (bn: BigNumberish, decimals = 18): number => {
  return parseFloat(formatUnits(bn, decimals));
};

export default bigNumberToNumber;
